sv.i18n.portlet=sv.i18n.portlet || {};
sv.i18n.portlet.comments2=sv.i18n.portlet.comments2 || {};
sv.i18n.portlet.comments2.comments=sv.i18n.portlet.comments2.comments || {};
sv.i18n.portlet.comments2.comments.de={
   "moderatedBody": "Die Kommentarfunktion wird moderiert.\nIhr Kommentar wird erst sichtbar, wenn ein Moderator ihn genehmigt hat.",
   "removeReplyTitle": "Antwort entfernen",
   "noNameHeading": "Kein Name",
   "showLess": "Weniger anzeigen",
   "postFailedHeading": "FEHLER",
   "hiddenComment": "Verborgener Kommentar",
   "removeReplyBody": "Sind Sie sicher, dass Sie die Antwort löschen möchten?",
   "editReplyTitle": "Antwort bearbeiten",
   "removeCommentBody": "Sind Sie sicher, dass Sie den Kommentar löschen möchten?",
   "moderatedHeading": "Modereriertes Kommentarfeld",
   "doReply": "Antworten",
   "removeCommentTitle": "Kommentar entfernen",
   "reply": "Antworten",
   "commentToLongHeading": "Zu lang",
   "replies": "Antworten",
   "hiddenReply": "Verborgene Antwort",
   "commentToLongBody": "Der Kommentar, den Sie senden wollten, war zu lang.",
   "editCommentTitle": "Kommentar bearbeiten",
   "save": "Speichern",
   "showMore": "Mehr anzeigen",
   "postFailedBody": "Es ist ein Fehler aufgetreten, der Kommentar wurde nicht veröffentlicht.",
   "noNameBody": "Kein Name angegeben Name ist obligatorisch"
};
sv.i18n.portlet.comments2.comments.en={
   "moderatedBody": "The comments function is moderated.\nYour comment will become visible only after a moderator has approved it.",
   "removeReplyTitle": "Delete reply",
   "noNameHeading": "No name",
   "showLess": "Show less",
   "postFailedHeading": "ERROR",
   "hiddenComment": "Hidden comment",
   "removeReplyBody": "Are you sure you want to delete the reply?",
   "editReplyTitle": "Edit reply",
   "removeCommentBody": "Are you sure you want to delete the comment?",
   "moderatedHeading": "Moderated comments field",
   "doReply": "Reply",
   "removeCommentTitle": "Delete comment",
   "reply": "reply",
   "commentToLongHeading": "Too long",
   "replies": "replies",
   "hiddenReply": "Hidden reply",
   "showMore": "Show more",
   "commentToLongBody": "The comment you where trying to post was too long.",
   "editCommentTitle": "Edit comment",
   "save": "Save",
   "postFailedBody": "An error has occurred, the comment was not published.",
   "noNameBody": "No name given. Name is mandatory"
};
sv.i18n.portlet.comments2.comments.es={
   "moderatedBody": "La función de comentarios tiene moderador.\nTu comentario será visible cuando el moderador lo apruebe.",
   "removeReplyTitle": "Eliminar respuesta",
   "noNameHeading": "Sin nombre",
   "showLess": "Mostrar menos",
   "postFailedHeading": "ERROR",
   "hiddenComment": "Comentario oculto",
   "removeReplyBody": "¿Estás seguro de que deseas eliminar la respuesta?",
   "editReplyTitle": "Editar respuesta",
   "removeCommentBody": "¿Estás seguro de que deseas eliminar el comentario?",
   "moderatedHeading": "Campo de comentario con moderador",
   "doReply": "Responder",
   "removeCommentTitle": "Eliminar comentario",
   "reply": "respuesta",
   "commentToLongHeading": "Demasiado largo",
   "replies": "respuesta",
   "hiddenReply": "Respuesta oculta",
   "commentToLongBody": "El comentario que intentabas enviar era demasiado largo...",
   "editCommentTitle": "Editar comentario",
   "save": "Guardar",
   "showMore": "Mostrar más",
   "postFailedBody": "Ha ocurrido un error, el comentario no se ha publicado.",
   "noNameBody": "No se ha indicado nombre. El nombre es obligatorio"
};
sv.i18n.portlet.comments2.comments.fi={
   "removeCommentBody": "Oletko varma, että haluat poistaa kommentin?",
   "commentToLongHeading": "Liian pitkä",
   "removeCommentTitle": "Poista kommentti",
   "showMore": "Näytä lisää",
   "noNameBody": "Nimeä ei annettu. Nimi on pakollinen",
   "showLess": "Näytä vähemmän",
   "commentToLongBody": "Yritit lähettää liian pitkän kommentin.",
   "moderatedHeading": "Moderoitu kommenttikenttä",
   "save": "Tallenna",
   "moderatedBody": "Kommentointitoiminto on moderoitu.\nKommenttisi tulee näkyviin, kun moderaattori on hyväksynyt sen.",
   "hiddenComment": "Poistunut kommentti",
   "noNameHeading": "Ei nimeä",
   "postFailedHeading": "VIRHE",
   "postFailedBody": "Tapahtui virhe, kommenttia ei julkaistu."
};
sv.i18n.portlet.comments2.comments.fr={
   "moderatedBody": "La fonction de commentaire est modérée.\nVotre commentaire ne sera visible que lorsqu'un modérateur l'aura approuvé.",
   "removeReplyTitle": "Supprimer les réponses",
   "noNameHeading": "Pas de nom",
   "showLess": "Afficher moins",
   "postFailedHeading": "ERREUR",
   "hiddenComment": "Commentaire masqué",
   "removeReplyBody": "Voulez-vous vraiment supprimer la réponse ?",
   "editReplyTitle": "Editer la réponse",
   "removeCommentBody": "Voulez-vous vraiment supprimer le commentaire ?",
   "moderatedHeading": "Champ de commentaires modéré",
   "doReply": "Répondre",
   "removeCommentTitle": "Supprimer le commentaire",
   "reply": "réponse",
   "commentToLongHeading": "Trop long",
   "replies": "réponse",
   "hiddenReply": "Réponse masquée",
   "commentToLongBody": "Le commentaire que vous avez essayé d'envoyer était trop long.",
   "editCommentTitle": "Editer le commentaire",
   "save": "Sauvegarder",
   "showMore": "Afficher plus",
   "postFailedBody": "Une erreur s'est produite, le commentaire n'a pas été publié.",
   "noNameBody": "Aucun nom n'est indiqué. Le nom est obligatoire"
};
sv.i18n.portlet.comments2.comments.no={
   "Din": "kommentar blir synlig først når en moderator har godkjent den.",
   "moderatedBody": "Kommentarfunksjonen er moderert.",
   "removeReplyTitle": "Fjern svar",
   "noNameHeading": "Intet navn",
   "showLess": "Vis mindre",
   "postFailedHeading": "FEIL",
   "hiddenComment": "Skjult kommentar",
   "removeReplyBody": "Er du sikker på at du vil fjerne svaret?",
   "editReplyTitle": "Rediger svar",
   "removeCommentBody": "Er du sikker på at du vil fjerne kommentaren?",
   "moderatedHeading": "Moderert kommentarfelt",
   "doReply": "Svar",
   "removeCommentTitle": "Fjern kommentar",
   "reply": "svar",
   "commentToLongHeading": "For lang",
   "replies": "svar",
   "hiddenReply": "Skjult svar",
   "showMore": "Vis mer",
   "commentToLongBody": "Kommentaren du forsøkte å sende, var for lang.",
   "save": "Lagre",
   "editCommentTitle": "Rediger kommentar",
   "postFailedBody": "Det oppsto en feil, kommentaren ble ikke publisert.",
   "noNameBody": "Intet navn angitt. Navn er obligatorisk"
};
sv.i18n.portlet.comments2.comments.sv={
   "moderatedBody": "Kommentarsfunktionen är modererad.\nDin kommentar blir synlig först när en moderator godkänt den.",
   "removeReplyTitle": "Ta bort svar",
   "noNameHeading": "Inget namn",
   "showLess": "Visa mindre",
   "postFailedHeading": "FEL",
   "hiddenComment": "Dold kommentar",
   "removeReplyBody": "Är du säker på att du vill ta bort svaret?",
   "editReplyTitle": "Redigera svar",
   "removeCommentBody": "Är du säker på att du vill ta bort kommentaren?",
   "moderatedHeading": "Modererat kommentarsfält",
   "doReply": "Svara",
   "removeCommentTitle": "Ta bort kommentar",
   "reply": "svar",
   "commentToLongHeading": "För lång",
   "replies": "svar",
   "hiddenReply": "Dolt svar",
   "showMore": "Visa mer",
   "commentToLongBody": "Kommentaren du försökte skicka var för lång.",
   "editCommentTitle": "Redigera kommentar",
   "save": "Spara",
   "postFailedBody": "Ett fel har uppstått, kommentaren publicerades inte.",
   "noNameBody": "Inget namn angivet. Namn är obligatoriskt"
};
